import React from 'react';
import { Phone, Smartphone, Mail } from 'lucide-react';

const Header = () => {
  return (
    <header className="bg-white text-gray-800 py-2 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-between items-center">
          {/* Logo */}
          <div className="flex items-center">
            <img src="/images/logo.webp" alt="Mas Metal S.R.L." className="h-8" />
          </div>
          
          {/* Informazioni di contatto */}
          <div className="flex flex-wrap items-center text-xs">
            <a href="tel:+390307998505" className="flex items-center hover:text-gray-600 transition-colors duration-200">
              <Phone size={14} className="text-gray-500 mr-1" />
              <span>+39 0307998505</span>
            </a>
            
            <div className="mx-2 text-gray-300">|</div>
            
            <a href="tel:+393482920338" className="flex items-center hover:text-gray-600 transition-colors duration-200">
              <Smartphone size={14} className="text-gray-500 mr-1" />
              <span>+39 3482920338</span>
            </a>
            
            <div className="mx-2 text-gray-300">|</div>
            
            <a href="mailto:info@masmetalsrl.com" className="flex items-center hover:text-gray-600 transition-colors duration-200">
              <Mail size={14} className="text-gray-500 mr-1" />
              <span>info@masmetalsrl.com</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;